/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const validateApiKeyRequestRequestSchema = z
	.object({
		api_key: z.string().min(1),
	})
	.describe("Сериализатор для валидации API-key, введенного на киоске.");
